/**
 * TileErrorBoundary — catches render-time errors in any one tile so a single
 * bad tile (bad data shape, missing chart-type module, etc.) doesn't unmount
 * the whole BoardDetail. The other tiles keep rendering; this one shows an
 * inline error chrome with the message.
 */
import React from 'react';
import { Box, Text } from '@chakra-ui/react';

export default class TileErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    // Console-log so devs can find it; do not propagate.
    // eslint-disable-next-line no-console
    console.error('[TileErrorBoundary] tile crashed:', this.props.tileTitle || '', error, info?.componentStack);
  }
  render() {
    if (this.state.error) {
      return (
        <Box p={3} bg="red.50" borderRadius="md" borderLeft="3px solid" borderColor="red.400">
          <Text fontSize="xs" fontWeight="medium" color="red.700">⚠ Tile crashed</Text>
          <Text fontSize="xs" color="red.600" mt={1} fontFamily="mono">
            {this.state.error?.message || String(this.state.error)}
          </Text>
          <Text fontSize="xs" color="gray.600" mt={2}>
            The rest of the board is unaffected — open the tile's 3-dot menu → View config to inspect.
          </Text>
        </Box>
      );
    }
    return this.props.children;
  }
}
